import { Fragment } from 'react'
import { css } from '@emotion/react'
import CloudQueueIcon from '@mui/icons-material/CloudQueue'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import LoopIcon from '@mui/icons-material/Loop'
import StorageIcon from '@mui/icons-material/Storage'
import TimerIcon from '@mui/icons-material/Timer'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import Divider from '@mui/material/Divider'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import moment from 'moment'
import PropTypes from 'prop-types'
import AiCreativeIcon from 'images/ai-creative.svg'
import { EventLogEntry } from './event-log-entry'
import {
  COMPLETED,
  EXPORTING_DATA,
  PROCESSING,
  VALIDATING,
  WAITING_ON_DATA,
  WAITING_ON_PROCESSOR,
  WAITING_TO_START,
  GENERATING_CLASSIFICATION,
} from '../../global/constants/datasetSubmissionEventGroupType'

const GROUP_ICONS = {
  [WAITING_TO_START]: TimerIcon,
  [WAITING_ON_DATA]: StorageIcon,
  [WAITING_ON_PROCESSOR]: TimerIcon,
  [PROCESSING]: LoopIcon,
  [VALIDATING]: VerifiedUserIcon,
  [EXPORTING_DATA]: CloudQueueIcon,
  [COMPLETED]: DoneAllIcon,
  [GENERATING_CLASSIFICATION]: AiCreativeIcon,
}

const GROUP_MESSAGES = {
  [WAITING_TO_START]: 'Starting Submission process',
  [WAITING_ON_DATA]: 'Waiting for data to fully load',
  [WAITING_ON_PROCESSOR]: 'Waiting for data processor to become available',
  [PROCESSING]: 'Processing Submission data',
  [VALIDATING]: 'Validating Submission data',
  [EXPORTING_DATA]: 'Sending data to remote systems',
  [COMPLETED]: 'Completed',
  [GENERATING_CLASSIFICATION]: 'Generating Classification',
}

const row = css`
  display: flex;
  align-items: center;
  min-height: 48px;
`

const colLeft = css`
  width: 96px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const colMiddle = css`
  flex: 1;
`

const colRight = css`
  width: 128px;
`

const iconContainer = css`
  height: 32px;
  width: 32px;
  padding: 6px;
  border-radius: 50%;
  background: #9fcdff;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: contain;

  svg:not(.MuiSvgIcon-root) {
    path {
      fill: white;
    }
  }
`

const divider = css`
  margin-left: 84px; //96 - 12
`

const groupMessageCss = css`
  color: #0060c0;
  font-weight: 300;
  font-size: 18px;
`

const groupDateCss = css`
  color: #666;
  font-weight: 300;
  font-size: 16px;
`

export function EventGroup({ group }) {
  const Icon = GROUP_ICONS[group.groupType] || HelpOutlineIcon
  const groupMessage = GROUP_MESSAGES[group.groupType] || ''
  return (
    <Paper elevation={1} style={{ marginBottom: 36, position: 'relative' }}>
      <div css={row}>
        <div css={colLeft}>
          <Paper css={iconContainer}>
            <Icon />
          </Paper>
        </div>
        <div css={colMiddle}>
          <Typography css={groupMessageCss}>{groupMessage}</Typography>
        </div>
        <div css={colRight}>
          <Typography css={groupDateCss}>
            {moment(group.events[0].createdAt).format('MMM D, YYYY')}
          </Typography>
        </div>
      </div>

      <div>
        {group.events.map((event, idx) => {
          const isLast = idx === group.events.length - 1
          return (
            <Fragment key={event.id}>
              <EventLogEntry entry={event} />
              {!isLast && <Divider variant="middle" css={divider} />}
            </Fragment>
          )
        })}
      </div>
    </Paper>
  )
}

EventGroup.propTypes = {
  group: PropTypes.shape({
    groupType: PropTypes.number.isRequired,
    events: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
}
